module.exports = __webpack_public_path__ + "img/newsDemo1.33b72784.png";